import $ from "jquery"
import "slick-carousel-latest"

$(".slider").slick({
    // normal options...
    infinite: false,
    arrows: true,
});
